const sxStyles = ({ breakpoints, palette, spacing, transitions }) => ({
    root: {
        display: "flex",
        flexFlow: "column nowrap",
        flex: 1,
        paddingTop: spacing(6),
        backgroundColor: palette.background.default,
        transition: transitions.create(["padding-left"], {
            duration: transitions.duration.leavingScreen,
            delay: transitions.duration.complex,
        }),
        [breakpoints.up("xl")]: {
            transition: transitions.create(["padding-left"], {
                duration: transitions.duration.enteringScreen,
                delay: transitions.duration.shortest,
            }),
        },
    },
    main: {
        padding: spacing(3, 3, 3, 3),
    },
});
export default sxStyles;
//# sourceMappingURL=Main.style.js.map